import { render, staticRenderFns } from "./an-a-z-anatomy-activity.vue?vue&type=template&id=628cb7ce&"
import script from "./an-a-z-anatomy-activity.vue?vue&type=script&lang=js&"
export * from "./an-a-z-anatomy-activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports